(function () {
  const header = document.querySelector("header");
  const triggers = Array.prototype.slice.call(document.querySelectorAll("[data-mega-trigger]"));
  const panels = Array.prototype.slice.call(document.querySelectorAll("[data-mega-panel]"));
  let closeTimer = null;
  let activeName = "";

  function panelFor(name) {
    return document.querySelector('[data-mega-panel="' + name + '"]');
  }

  function clearCloseTimer() {
    if (closeTimer) {
      window.clearTimeout(closeTimer);
      closeTimer = null;
    }
  }

  const desktopNav = window.matchMedia("(min-width: 1200px)");

  function setTriggerState(trigger, open) {
    trigger.setAttribute("aria-expanded", open ? "true" : "false");
    trigger.classList.toggle("is-open", open);
    const chevron = trigger.querySelector("[data-mega-chevron]");
    if (chevron) chevron.style.transform = open ? "rotate(180deg)" : "";
  }

  function closeMenus() {
    clearCloseTimer();
    activeName = "";
    if (header) header.removeAttribute("data-active-mega-menu");
    panels.forEach(function (panel) {
      panel.classList.remove("is-open");
    });
    triggers.forEach(function (trigger) {
      setTriggerState(trigger, false);
    });
  }

  function openMenu(name) {
    if (!name || !desktopNav.matches) return;
    clearCloseTimer();
    activeName = name;
    if (header) header.setAttribute("data-active-mega-menu", name);
    panels.forEach(function (panel) {
      panel.classList.toggle("is-open", panel.getAttribute("data-mega-panel") === name);
    });
    triggers.forEach(function (trigger) {
      setTriggerState(trigger, trigger.getAttribute("data-mega-trigger") === name);
    });
  }

  function scheduleClose() {
    clearCloseTimer();
    closeTimer = window.setTimeout(closeMenus, 150);
  }

  triggers.forEach(function (trigger) {
    trigger.addEventListener("mouseenter", function () {
      openMenu(trigger.getAttribute("data-mega-trigger"));
    });
    trigger.addEventListener("mouseleave", scheduleClose);
    trigger.addEventListener("focus", function () {
      openMenu(trigger.getAttribute("data-mega-trigger"));
    });
    trigger.addEventListener("keydown", function (event) {
      if (event.key !== "ArrowDown") return;
      event.preventDefault();
      const name = trigger.getAttribute("data-mega-trigger");
      openMenu(name);
      const panel = panelFor(name);
      const firstLink = panel && panel.querySelector("a");
      if (firstLink) firstLink.focus();
    });
  });

  panels.forEach(function (panel) {
    panel.addEventListener("mouseenter", clearCloseTimer);
    panel.addEventListener("mouseleave", scheduleClose);
  });

  document.addEventListener("click", function (event) {
    if (event.target.closest("[data-mega-trigger], [data-mega-panel]")) return;
    if (activeName) closeMenus();
  });

  const mobileMenuBtn = document.getElementById("mobile-menu-btn");
  const closeMobileMenu = document.getElementById("close-mobile-menu");
  const mobileDrawer = document.getElementById("mobile-drawer");
  const mobileBackdrop = document.getElementById("mobile-backdrop");

  function openDrawer() {
    if (!mobileDrawer) return;
    closeMenus();
    mobileDrawer.classList.remove("-translate-x-full");
    if (mobileBackdrop) mobileBackdrop.hidden = false;
    document.body.style.overflow = "hidden";
  }

  function closeDrawer() {
    if (!mobileDrawer) return;
    mobileDrawer.classList.add("-translate-x-full");
    if (mobileBackdrop) mobileBackdrop.hidden = true;
    document.body.style.overflow = "";
  }

  if (mobileMenuBtn && mobileDrawer) {
    mobileMenuBtn.addEventListener("click", openDrawer);
    if (closeMobileMenu) closeMobileMenu.addEventListener("click", closeDrawer);
    if (mobileBackdrop) mobileBackdrop.addEventListener("click", closeDrawer);
  }

  const favoriteKey = "noirplate_favorites";
  const wishlistCounter = document.getElementById("wishlist-counter");

  function slug(value) {
    return String(value || "")
      .toLowerCase()
      .replace(/['’]/g, "")
      .replace(/&/g, " ")
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "");
  }

  function readFavorites() {
    try {
      const current = JSON.parse(localStorage.getItem(favoriteKey) || "null");
      if (Array.isArray(current)) {
        return current.filter(function (item) { return typeof item === "string" && item; });
      }
    } catch (error) {
      return [];
    }
    try {
      const legacy = JSON.parse(localStorage.getItem("noirplate-favorites") || "[]");
      if (!Array.isArray(legacy)) return [];
      const migrated = legacy.map(function (item) {
        if (!item || typeof item !== "object") return "";
        const url = String(item.url || "");
        const match = url.match(/\/products\/([^/?#]+)/);
        if (match) return decodeURIComponent(match[1]);
        if (item.title) return "sample-" + slug(item.title);
        return "";
      }).filter(Boolean);
      localStorage.setItem(favoriteKey, JSON.stringify(migrated));
      return migrated;
    } catch (error) {
      return [];
    }
  }

  function writeFavorites(items) {
    localStorage.setItem(favoriteKey, JSON.stringify(items));
    paintBadge(items);
  }

  function paintBadge(items) {
    if (!wishlistCounter) return;
    wishlistCounter.textContent = String(items.length);
    wishlistCounter.hidden = items.length === 0;
  }

  function cardRoot(button) {
    return button.closest("article") || button.closest(".group");
  }

  function cardTitle(button) {
    const card = cardRoot(button);
    if (!card) return "";
    const heading = card.querySelector("h1, h2, h3, h4");
    if (heading) return heading.textContent.replace(/\s+/g, " ").trim();
    const named = card.querySelector(".font-medium, .font-body-md");
    return named ? named.textContent.replace(/\s+/g, " ").trim() : "";
  }

  function favoriteHandle(button) {
    if (button.getAttribute("data-favorite-handle")) return button.getAttribute("data-favorite-handle");
    const title = cardTitle(button);
    return title ? "sample-" + slug(title) : "";
  }

  function isHeartButton(button) {
    if (!button || button.tagName !== "BUTTON") return false;
    if (button.closest("header") || button.closest("#mobile-drawer")) return false;
    if (button.classList.contains("wishlist-btn") || button.getAttribute("data-wishlist-label") === "pdp") return true;
    const icon = button.querySelector(".material-symbols-outlined");
    if (!icon) return false;
    const name = icon.textContent.replace(/\s+/g, "");
    return name === "favorite" || name === "favorite_border";
  }

  function paintHeart(button, saved) {
    const icon = button.querySelector(".material-symbols-outlined");
    if (icon) {
      icon.textContent = saved ? "favorite" : "favorite_border";
      icon.style.fontVariationSettings = saved
        ? "'FILL' 1, 'wght' 300, 'GRAD' 0, 'opsz' 24"
        : "'FILL' 0, 'wght' 300, 'GRAD' 0, 'opsz' 24";
    }
    if (button.getAttribute("data-wishlist-label") === "pdp") {
      const label = button.querySelector("[data-wishlist-text]") || button;
      label.textContent = saved ? "\u2665 SAVED TO FAVORITES" : "\u2661 ADD TO WISHLIST";
    }
    button.setAttribute("aria-pressed", saved ? "true" : "false");
  }

  function syncHearts(items) {
    document.querySelectorAll("button").forEach(function (button) {
      if (!isHeartButton(button)) return;
      const handle = favoriteHandle(button);
      if (handle && !button.getAttribute("data-favorite-handle")) {
        button.setAttribute("data-favorite-handle", handle);
      }
      button.classList.add("wishlist-btn");
      paintHeart(button, handle && items.indexOf(handle) !== -1);
    });
  }

  function humanize(handle) {
    return String(handle || "")
      .replace(/^sample-/, "")
      .replace(/-/g, " ")
      .replace(/\b\w/g, function (letter) { return letter.toUpperCase(); });
  }

  function cloneSample(handle) {
    const pool = document.getElementById("FavoriteSamplePool");
    if (!pool) return null;
    const match = pool.querySelector('[data-favorite-handle="' + handle + '"]');
    const source = (match && match.closest("article")) || pool.querySelector("article");
    if (!source) return null;
    const clone = source.cloneNode(true);
    const button = clone.querySelector(".wishlist-btn");
    if (button) button.setAttribute("data-favorite-handle", handle);
    if (!match) {
      const heading = clone.querySelector("h1, h2, h3, h4");
      const title = humanize(handle);
      if (heading) {
        const link = heading.querySelector("a");
        if (link) link.textContent = title;
        else heading.textContent = title;
      }
    }
    return clone;
  }

  function paintFavorites() {
    const grid = document.getElementById("FavoritesGrid");
    const empty = document.getElementById("FavoritesEmpty");
    const suggestions = document.getElementById("FavoritesSuggestions");
    if (!grid || !empty) return;
    const items = readFavorites();
    const hasItems = items.length > 0;
    empty.style.display = hasItems ? "none" : "";
    grid.style.display = hasItems ? "grid" : "none";
    grid.classList.remove("hidden");
    if (suggestions) suggestions.classList.remove("hidden");
    grid.innerHTML = "";
    items.forEach(function (handle) {
      if (handle.indexOf("sample-") === 0) {
        const node = cloneSample(handle);
        if (node) grid.appendChild(node);
        return;
      }
      const slot = document.createElement("div");
      slot.setAttribute("data-favorite-slot", handle);
      grid.appendChild(slot);
      fetch("/products/" + encodeURIComponent(handle) + "?view=card", { credentials: "same-origin" })
        .then(function (response) { return response.ok ? response.text() : ""; })
        .then(function (html) {
          const current = readFavorites();
          if (current.indexOf(handle) === -1 || !slot.parentNode) return;
          const wrap = document.createElement("div");
          wrap.innerHTML = html.trim();
          const card = wrap.querySelector("article");
          if (card) slot.replaceWith(card);
          else slot.remove();
          syncHearts(readFavorites());
        })
        .catch(function () {
          if (slot.parentNode) slot.remove();
        });
    });
    syncHearts(items);
  }

  const initialFavorites = readFavorites();
  paintBadge(initialFavorites);
  syncHearts(initialFavorites);
  paintFavorites();
  document.addEventListener("noirplate:sync", function () {
    syncHearts(readFavorites());
  });

  document.addEventListener("click", function (event) {
    const button = event.target.closest("button");
    if (!isHeartButton(button)) return;
    event.preventDefault();
    event.stopPropagation();
    const handle = favoriteHandle(button);
    if (!handle) return;
    const items = readFavorites();
    const index = items.indexOf(handle);
    if (index === -1) items.push(handle);
    else items.splice(index, 1);
    writeFavorites(items);
    syncHearts(items);
    paintFavorites();
  });

  const searchPanel = document.getElementById("PredictiveSearch");
  const searchButton = document.getElementById("HeaderSearch");
  const searchInput = document.getElementById("PredictiveSearchInput");

  let searchScrollY = 0;

  function placeSearch() {
    const header = document.querySelector(".np-header");
    let top = 100;
    if (header) top = Math.max(0, Math.round(header.getBoundingClientRect().bottom));
    document.documentElement.style.setProperty("--np-header-height", top + "px");
  }

  function openSearch() {
    if (!searchPanel) return;
    closeMenus();
    searchScrollY = window.scrollY || window.pageYOffset || 0;
    placeSearch();
    if (searchInput) searchInput.value = "";
    searchPanel.classList.remove("hidden");
    searchPanel.setAttribute("aria-hidden", "false");
    document.body.classList.add("noirplate-search-open");
    placeSearch();
    document.dispatchEvent(new CustomEvent("noirplate:search-open"));
    if (searchInput) searchInput.focus();
    window.requestAnimationFrame(placeSearch);
  }

  function closeSearch() {
    if (!searchPanel || searchPanel.classList.contains("hidden")) return;
    searchPanel.classList.add("hidden");
    searchPanel.setAttribute("aria-hidden", "true");
    document.body.classList.remove("noirplate-search-open");
    window.scrollTo(0, searchScrollY);
  }

  if (searchButton) {
    searchButton.addEventListener("click", function () {
      if (!searchPanel) return;
      if (searchPanel.classList.contains("hidden")) openSearch();
      else closeSearch();
    });
  }

  const searchClose = document.getElementById("PredictiveSearchClose");
  if (searchClose) {
    searchClose.addEventListener("click", function (event) {
      event.preventDefault();
      closeSearch();
    });
  }

  if (searchPanel) {
    searchPanel.addEventListener("click", function (event) {
      if (event.target.closest(".np-search__head, #PredictiveResults, a, button, input, form")) return;
      closeSearch();
    });
  }

  window.addEventListener("resize", function () {
    if (searchPanel && !searchPanel.classList.contains("hidden")) placeSearch();
  });

  function searchScrollLocked(event) {
    if (!document.body.classList.contains("noirplate-search-open")) return;
    const results = document.getElementById("PredictiveResults");
    if (results && !results.classList.contains("hidden") && results.contains(event.target)) return;
    event.preventDefault();
  }

  document.addEventListener("wheel", searchScrollLocked, { passive: false });
  document.addEventListener("touchmove", searchScrollLocked, { passive: false });
  window.addEventListener("scroll", function () {
    if (!document.body.classList.contains("noirplate-search-open")) return;
    if (Math.abs((window.scrollY || 0) - searchScrollY) > 1) window.scrollTo(0, searchScrollY);
  });

  const faqSearch = document.getElementById("faq-search");
  if (faqSearch) {
    faqSearch.addEventListener("input", function () {
      const query = faqSearch.value.trim().toLowerCase();
      document.querySelectorAll("details:not([data-mobile-accordion])").forEach(function (item) {
        const text = item.textContent.toLowerCase();
        item.classList.toggle("hidden", query.length > 0 && text.indexOf(query) === -1);
      });
    });
  }

  document.addEventListener("keydown", function (event) {
    if (event.key !== "Escape") return;
    closeSearch();
    closeQuickView();
    if (activeName) {
      const current = document.querySelector('[data-mega-trigger="' + activeName + '"]');
      closeMenus();
      if (current) current.focus();
    }
  });

  if (desktopNav.addEventListener) {
    desktopNav.addEventListener("change", function () {
      if (!desktopNav.matches) closeMenus();
    });
  }

  const quickView = document.getElementById("QuickView");
  const quickPanel = document.getElementById("QuickViewPanel");

  let quickReturn = null;

  let lockedScroll = null;

  function lockPage() {
    if (lockedScroll !== null) return;
    lockedScroll = window.scrollY || window.pageYOffset || 0;
    document.body.style.position = "fixed";
    document.body.style.top = "-" + lockedScroll + "px";
    document.body.style.left = "0";
    document.body.style.right = "0";
    document.body.style.width = "100%";
  }

  function unlockPage() {
    if (lockedScroll === null) return;
    const y = lockedScroll;
    lockedScroll = null;
    document.body.style.position = "";
    document.body.style.top = "";
    document.body.style.left = "";
    document.body.style.right = "";
    document.body.style.width = "";
    window.scrollTo(0, y);
  }

  function closeQuickView() {
    if (!quickView) return;
    if (typeof quickView.close === "function" && quickView.open) quickView.close();
    if (quickPanel) quickPanel.innerHTML = "";
    unlockPage();
  }

  function money(cents) {
    const format = (window.noirplate && window.noirplate.moneyFormat) || "${{amount}}";
    return format.replace(/\{\{\s*amount\s*\}\}/g, (cents / 100).toFixed(2));
  }

  function esc(value) {
    return String(value == null ? "" : value).replace(/[&<>"']/g, function (char) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[char];
    });
  }

  function imageSrc(image) {
    if (!image) return "";
    if (typeof image === "string") return image;
    return image.src || image.url || "";
  }

  function quickShell(html) {
    if (!quickPanel || !quickView) return;
    quickPanel.innerHTML = html;
    if (typeof quickView.showModal === "function" && !quickView.open) quickView.showModal();
    lockPage();
    syncHearts(readFavorites());
    const closeBtn = quickPanel.querySelector("[data-quick-close]");
    if (closeBtn) closeBtn.focus();
  }

  if (quickView) {
    quickView.addEventListener("close", function () {
      unlockPage();
      if (quickReturn && typeof quickReturn.focus === "function") quickReturn.focus();
    });
    quickView.addEventListener("click", function (event) {
      if (event.target === quickView) closeQuickView();
    });
  }

  function renderSampleQuick(button) {
    const title = button.getAttribute("data-sample-title") || "Artwork";
    const price = button.getAttribute("data-sample-price") || "";
    const image = button.getAttribute("data-sample-image") || "";
    const url = button.getAttribute("data-sample-url") || "/";
    const handle = button.getAttribute("data-product-handle") || "";
    quickShell(
      '<button class="np-qv-close" type="button" data-quick-close aria-label="Close"><span class="material-symbols-outlined">close</span></button>' +
      '<div class="np-qv">' +
        '<div class="np-qv-gallery">' + (image ? '<img class="np-qv-main" alt="" src="' + esc(image) + '">' : "") + "</div>" +
        '<div class="np-qv-info">' +
          '<h2 id="QuickViewTitle" class="font-headline-sm text-headline-sm text-primary">' + esc(title) + "</h2>" +
          '<p class="font-price-regular text-price-regular text-primary mt-4">' + esc(price) + "</p>" +
          '<p class="font-body-sm text-body-sm text-on-surface-variant mt-4">This is a sample preview. The live piece will show size, frame, and checkout once it is in the catalogue.</p>' +
          '<button class="mt-6 w-full h-12 border border-primary text-primary font-label-caps text-label-caps uppercase tracking-widest wishlist-btn" type="button" data-favorite-handle="' + esc(handle) + '"><span class="material-symbols-outlined">favorite_border</span> Add to favorites</button>' +
          '<a class="mt-3 w-full h-12 border border-primary text-primary font-label-caps text-label-caps uppercase tracking-widest flex items-center justify-center" href="' + esc(url) + '">View full details</a>' +
        "</div></div>"
    );
  }

  function startingVariant(product) {
    const variants = product.variants || [];
    const unframed = variants.find(function (item) {
      return (item.options || []).some(function (value) { return /no frame/i.test(String(value)); }) && item.available;
    });
    return unframed || variants.find(function (item) {
      return (item.options || []).some(function (value) { return /no frame/i.test(String(value)); });
    }) || variants[0];
  }

  function plainText(html) {
    return String(html || "").replace(/<[^>]+>/g, " ").replace(/\s+/g, " ").trim();
  }

  function productKind(product) {
    const blob = [product.type, product.handle, product.title].join(" ").toLowerCase();
    if (/accessor|hanger|hook|\bledge\b|\bclip\b|mat board|poster stand/.test(blob)) return "accessory";
    if (/canvas/.test(blob)) return "canvas";
    if (/gallery wall|\bset\b|bundle|poster pack/.test(blob)) return "set";
    if (/frame/.test(blob)) return "frame";
    return "poster";
  }

  function optionVisible(kind, name) {
    const label = String(name || "").toLowerCase();
    if (kind === "accessory") return true;
    if (kind === "canvas") return !/frame|finish/.test(label);
    if (kind === "frame") return /size|finish|frame|colour|color|style/.test(label);
    if (kind === "set") return /size|set|frame|layout/.test(label);
    return /size|frame/.test(label);
  }

  function frameValues(values) {
    const allowed = ["no frame", "black", "white", "natural oak", "dark oak"];
    const match = values.filter(function (value) {
      return allowed.indexOf(String(value).toLowerCase()) !== -1;
    });
    return match.length ? match : values;
  }

  function realImage(src) {
    if (!src || /googleusercontent|aida-public|screenshot/i.test(src)) return "";
    return src;
  }

  function renderProductQuick(product) {
    const kind = productKind(product);
    let variant = startingVariant(product);
    if (kind === "canvas") {
      variant = (product.variants || []).find(function (item) { return item.available; }) || variant;
    }
    if (!variant) {
      quickShell("<p class=\"font-body-md text-body-md p-8\">This piece is currently unavailable.</p>");
      return;
    }
    const options = (product.options || []).map(function (option, index) {
      const name = option.name || option;
      const values = [];
      (product.variants || []).forEach(function (item) {
        const value = item.options[index];
        if (values.indexOf(value) === -1) values.push(value);
      });
      const visibleValues = (kind === "poster" || kind === "set") && /frame/i.test(name) ? frameValues(values) : values;
      let selectedValue = variant.options ? variant.options[index] : "";
      if (visibleValues.indexOf(selectedValue) === -1) selectedValue = visibleValues[0];
      if (!optionVisible(kind, name) || String(name).toLowerCase() === "title") {
        return '<span hidden><button type="button" aria-pressed="true" data-option-index="' + index + '" data-option-value="' + esc(selectedValue) + '"></button></span>';
      }
      return '<p class="font-label-caps text-label-caps uppercase tracking-widest text-on-surface-variant mt-6 mb-3">' + esc(name) + "</p>" +
        visibleValues.map(function (value) {
          const pressed = value === selectedValue;
          return '<button class="np-option' + (pressed ? " is-on" : "") + '" type="button" aria-pressed="' + pressed + '" data-option-index="' + index + '" data-option-value="' + esc(value) + '">' + esc(value) + "</button>";
        }).join("");
    }).join("");
    const images = (product.images || []).map(imageSrc).map(realImage).filter(Boolean);
    const image = realImage(imageSrc(variant.featured_image)) || realImage(imageSrc(product.featured_image)) || images[0] || "";
    const thumbs = images.length > 1 ? images.map(function (src) {
      return '<button type="button" data-qv-src="' + esc(src) + '"><img alt="" src="' + esc(src) + '"></button>';
    }).join("") : "";
    const artist = product.vendor && !/noirplate/i.test(product.vendor) ? product.vendor : "";
    const blurb = plainText(product.description).slice(0, 220);
    const compare = variant.compare_at_price > variant.price ? money(variant.compare_at_price) : "";
    quickShell(
      '<button class="np-qv-close" type="button" data-quick-close aria-label="Close"><span class="material-symbols-outlined">close</span></button>' +
      '<div class="np-qv">' +
        '<div class="np-qv-gallery">' +
          (image ? '<img class="np-qv-main" data-quick-image alt="" src="' + esc(image) + '">' : "") +
          (thumbs ? '<div class="np-qv-thumbs">' + thumbs + "</div>" : "") +
        "</div>" +
        '<div class="np-qv-info">' +
          (product.type ? '<p class="font-label-caps text-label-caps uppercase tracking-widest text-on-surface-variant">' + esc(product.type) + "</p>" : "") +
          '<h2 id="QuickViewTitle" class="font-headline-sm text-headline-sm text-primary mt-2">' + esc(product.title) + "</h2>" +
          (artist ? '<p class="font-body-sm text-body-sm text-on-surface-variant mt-2">' + esc(artist) + "</p>" : "") +
          '<div class="flex items-baseline gap-3 mt-4"><span class="font-headline-sm text-headline-sm text-primary" data-quick-price>' + money(variant.price) + '</span><span class="font-price-strike text-price-strike text-outline line-through" data-quick-compare' + (compare ? "" : " hidden") + ">" + compare + "</span></div>" +
          '<p class="font-label-caps text-label-caps uppercase tracking-widest text-on-surface-variant mt-3" data-quick-stock>' + (variant.available ? "In stock" : "Sold out") + "</p>" +
          (blurb ? '<p class="font-body-md text-body-md text-on-surface-variant mt-4">' + esc(blurb) + "</p>" : "") +
          options +
          '<div class="mt-6">' +
            '<div class="inline-flex items-center border border-surface-variant">' +
              '<button class="w-12 h-12" type="button" data-quick-qty="-1" aria-label="Decrease quantity">−</button>' +
              '<input class="w-12 h-12 text-center bg-transparent" data-quick-qty-input value="1" type="number" min="1">' +
              '<button class="w-12 h-12" type="button" data-quick-qty="1" aria-label="Increase quantity">+</button>' +
            "</div>" +
            '<button class="mt-4 w-full h-12 bg-primary text-on-primary font-label-caps text-label-caps uppercase tracking-widest" type="button" data-quick-add="' + variant.id + '"' + (variant.available ? "" : " disabled") + ">Add to cart</button>" +
            '<button class="mt-3 w-full h-12 border border-primary text-primary font-label-caps text-label-caps uppercase tracking-widest" type="button" data-quick-buy="' + variant.id + '"' + (variant.available ? "" : " disabled") + ">Buy now</button>" +
            '<button class="mt-3 w-full h-12 border border-primary text-primary font-label-caps text-label-caps uppercase tracking-widest wishlist-btn" type="button" data-favorite-handle="' + esc(product.handle) + '"><span class="material-symbols-outlined">favorite_border</span> Add to favorites</button>' +
            '<a class="mt-4 inline-flex font-label-caps text-label-caps uppercase tracking-widest" href="' + esc(product.url) + '">View full details</a>' +
          "</div></div></div>"
    );
    quickPanel.dataset.product = JSON.stringify(product);
    quickPanel.dataset.variant = String(variant.id);
  }

  function selectQuickVariant(panel) {
    let product = null;
    try { product = JSON.parse(panel.dataset.product || "null"); } catch (error) { product = null; }
    if (!product || !product.variants) return;
    const selected = (product.options || []).map(function (_, index) {
      const active = panel.querySelector('[data-option-index="' + index + '"][aria-pressed="true"]');
      return active ? active.getAttribute("data-option-value") : product.variants[0].options[index];
    });
    const match = product.variants.find(function (item) {
      return (item.options || []).every(function (value, index) { return value === selected[index]; });
    });
    if (!match) return;
    const price = panel.querySelector("[data-quick-price]");
    const stock = panel.querySelector("[data-quick-stock]");
    const add = panel.querySelector("[data-quick-add]");
    const idInput = panel.querySelector('input[name="id"]');
    if (price) price.textContent = money(match.price);
    const compare = panel.querySelector("[data-quick-compare]");
    if (compare) {
      if (match.compare_at_price > match.price) {
        compare.textContent = money(match.compare_at_price);
        compare.hidden = false;
      } else {
        compare.textContent = "";
        compare.hidden = true;
      }
    }
    if (stock) stock.textContent = match.available ? "In stock" : "Sold out";
    if (add) {
      add.setAttribute("data-quick-add", String(match.id));
      add.disabled = !match.available;
      add.textContent = match.available ? "Add to cart" : "Sold out";
    }
    const buy = panel.querySelector("[data-quick-buy]");
    if (buy) {
      buy.disabled = !match.available;
      buy.setAttribute("data-quick-buy", String(match.id));
    }
    if (idInput) idInput.value = String(match.id);
    const image = panel.querySelector("[data-quick-image]");
    const src = imageSrc(match.featured_image);
    if (image && src) image.src = src;
    panel.dataset.variant = String(match.id);
  }

  function openQuickFrom(node) {
    if (!node) return;
    quickReturn = node;
    const handle = node.getAttribute("data-product-handle") || "";
    if (!handle || handle.indexOf("sample-") === 0) {
      renderSampleQuick(node);
      return;
    }
    fetch("/products/" + encodeURIComponent(handle) + ".js", { credentials: "same-origin" })
      .then(function (response) { return response.ok ? response.json() : null; })
      .then(function (product) {
        if (!product) renderSampleQuick(node);
        else renderProductQuick(product);
      })
      .catch(function () { renderSampleQuick(node); });
  }

  function cardSeed(event) {
    const heart = event.target.closest(".wishlist-btn, button");
    if (heart && heart.querySelector && heart.querySelector(".material-symbols-outlined")) {
      const icon = heart.querySelector(".material-symbols-outlined").textContent.replace(/\s+/g, "");
      if (icon === "favorite" || icon === "favorite_border") return null;
    }
    if (event.target.closest("#QuickView, .noirplate-mega-panel, #cart-drawer-panel, #mobile-drawer, .np-header")) return null;
    const direct = event.target.closest("[data-product-card]");
    if (direct) return direct;
    const host = event.target.closest("article, .group");
    if (!host || host.closest(".np-header, #QuickView")) return null;
    return host.querySelector(".np-card-seed, [data-quick-view]");
  }

  function buyNow(variantId, quantity) {
    const qty = Math.max(1, Number(quantity) || 1);
    fetch((window.noirplate && window.noirplate.routes && window.noirplate.routes.cartAdd || "/cart/add") + ".js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: Number(variantId), quantity: qty })
    }).then(function (response) {
      if (!response.ok) throw new Error("buy");
      const next = window.noirplate && window.noirplate.checkoutPreview
        ? (window.noirplate.checkoutPreviewUrl || "/pages/checkout-preview")
        : "/checkout";
      window.location.assign(next);
    });
  }

  document.addEventListener("click", function (event) {
    const seed = cardSeed(event);
    const opener = event.target.closest("[data-quick-view]");
    if (seed || opener) {
      event.preventDefault();
      if (opener && opener.classList && opener.classList.contains("wishlist-btn")) return;
      openQuickFrom(seed || opener);
      return;
    }
    const optionButton = event.target.closest("[data-option-index]");
    if (optionButton && quickPanel && quickPanel.contains(optionButton)) {
      const index = optionButton.getAttribute("data-option-index");
      quickPanel.querySelectorAll('[data-option-index="' + index + '"]').forEach(function (button) {
        button.setAttribute("aria-pressed", "false");
        button.classList.remove("is-on");
      });
      optionButton.setAttribute("aria-pressed", "true");
      optionButton.classList.add("is-on");
      selectQuickVariant(quickPanel);
      return;
    }
    const thumb = event.target.closest("[data-qv-src]");
    if (thumb && quickPanel && quickPanel.contains(thumb)) {
      const image = quickPanel.querySelector("[data-quick-image]");
      if (image) image.src = thumb.getAttribute("data-qv-src");
      return;
    }
    if (event.target.closest("[data-quick-close]")) closeQuickView();
    const buy = event.target.closest("[data-quick-buy]");
    if (buy && quickPanel && quickPanel.contains(buy) && !buy.disabled) {
      const qtyInput = quickPanel.querySelector("[data-quick-qty-input]");
      const quantity = qtyInput ? Math.max(1, Number(qtyInput.value) || 1) : 1;
      buyNow(buy.getAttribute("data-quick-buy"), quantity);
      return;
    }
    const add = event.target.closest("[data-quick-add]");
    if (add && window.noirplate && window.noirplate.routes) {
      const qtyInput = quickPanel.querySelector("[data-quick-qty-input]");
      const quantity = qtyInput ? Number(qtyInput.value) || 1 : 1;
      fetch(window.noirplate.routes.cartAdd + ".js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: Number(add.getAttribute("data-quick-add")), quantity: quantity })
      }).then(function (response) {
        if (!response.ok) throw new Error("add failed");
        closeQuickView();
        document.dispatchEvent(new CustomEvent("cart:refresh", { detail: { open: true } }));
      }).catch(function () {});
    }
    const qtyButton = event.target.closest("[data-quick-qty]");
    if (qtyButton && quickPanel) {
      const input = quickPanel.querySelector("[data-quick-qty-input]");
      if (!input) return;
      const next = Math.max(1, (Number(input.value) || 1) + Number(qtyButton.getAttribute("data-quick-qty")));
      input.value = String(next);
      const buyQty = quickPanel.querySelector('input[name="quantity"]');
      if (buyQty) buyQty.value = String(next);
    }
  });

  document.addEventListener("keydown", function (event) {
    if (event.key !== "Enter" && event.key !== " ") return;
    const card = event.target.closest("[data-product-card]");
    if (!card || event.target !== card) return;
    event.preventDefault();
    openQuickFrom(card);
  });

  document.addEventListener("click", function (event) {
    if (!window.noirplate || !window.noirplate.checkoutPreview) return;
    const link = event.target.closest("a[href]");
    if (!link) return;
    const href = link.getAttribute("href") || "";
    if (href === "/checkout" || /\/checkout\/?$/.test(href)) {
      event.preventDefault();
      window.location.assign(window.noirplate.checkoutPreviewUrl || "/pages/checkout-preview");
    }
  });

  window.NoirplateUI = { openSearch: openSearch, closeSearch: closeSearch };
})();
